import { makeAutoObservable } from 'mobx';
import {auth, types, endpoints} from 'main/tools';
import {DomainStore} from 'shared/store';
import {Employee} from 'main/stores/employees';
import {redirect} from 'shared/tools';

class OnboardEmergencyState {
  store = new DomainStore();

  employee;
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([
      endpoints.EMPLOYEE_DETAILS.with(auth.employee.id)
    ]);

    this.employee = new Employee(
      this.store._getSingle(types.EMPLOYEE_DETAILS, {id: auth.employee.id})
    );
  }

  async nextStep() {
    const {model, errors} = await this.store.patch(
      endpoints.EMPLOYEE_ONBOARD.EMERGENCY_INFO.with(auth.employee.id),
      types.EMPLOYEE_DETAILS,
      this.employee
    );
    this.errors = errors;

    if (model) {
      return redirect('/onboard');
    }
  }
}

export default OnboardEmergencyState;
